<style  scoped>
.left-content {
  width: 20%;
  height: 100%;
  padding: 20px;
  margin-right: 10px;
  background: #fff;
  border-radius: 4px;
}
.right-content {
  flex: 1;
  overflow: hidden;
}
.el-col-5 {
  width: 33%;
  margin-bottom: 15px;
}
.el-col-4 {
  width: 33%;
}
.payment-information {
  display: flex;
  align-items: center;
  width: 100%;
  margin-top: 30px;
  border: 1px solid #d2d2d3;
  border-radius: 4px;
  padding: 20px;
}
.pay-item {
  display: flex;
  width: 90%;
  margin-top: 10px;
  margin-bottom: 10px;
}
.pay-name {
  width: 100px;
  line-height: 32px;
  text-align: right;
  flex-shrink: 0;
  margin-right: 10px;
}
.pay-left {
  width: 100%;
}
.pay-right {
  width: 10%;
  /* flex-shrink: 0; */
}
.i-edit-sty {
  font-size: 20px;
  margin-right: 8px;
}
.i-sty {
  font-size: 20px;
}
.btn {
  display: none;
}
.btn i {
  cursor: pointer;
}
.el-table__body tr:hover .btn {
  display: block;
}
/deep/.el-pagination {
  overflow-x: auto;
}
/deep/.el-tabs__header {
  margin: 0;
}
/deep/ .el-tabs--card > .el-tabs__header .el-tabs__nav {
  border: 0 none;
}
/deep/ .el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
  border: 0 none;
}
/deep/ .el-tabs--card > .el-tabs__header .el-tabs__item {
  border: 0 none;
}
/deep/ .el-tabs__nav-next {
  font-size: 20px;
}
/deep/.el-tabs__nav-prev {
  font-size: 20px;
}
/deep/.el-tabs__new-tab {
  margin-right: 16px;
}
.top {
  background: #fff;
  margin-bottom: 16px;
}
</style>
<template>
  <div class="content">
    <div class="top">
      <p class="t-left font-S14 fontC-4fa1a4" style="padding:20px 0 0 16px" v-show="$route.query.pageTitle">{{$route.query.pageTitle}}</p>
      <el-tabs v-model="editableTabsValue" type="card" addable @edit="handleTabsEdit">
        <el-tab-pane :key="item.guid" v-for="item in editableTabs" :label="item.organisationName" :name="item.guid" @click="changeTab">
        </el-tab-pane>
      </el-tabs>
    </div>
    <div style="display: flex">
      <div class="left-content">
        <el-button icon="el-icon-plus" class="w100f" @click="addSales">新增销售区域</el-button>
        <!-- <el-button icon="el-icon-plus" class="w100f" @click="add" style="margin-left: 0; margin-top: 10px"
          >批量添加指标</el-button
        > -->
        <el-table
          :data="tableData"
          class="mt15"
          ref="singleTable"
          highlight-current-row
          @row-click="handle"
          :show-header="false"
        >
          <el-table-column prop="territoryName">
            <template slot-scope="scope">
              <div v-show="!sh[scope.$index]">{{ scope.row.territoryName }}</div>
              <el-input v-show="sh[scope.$index]" v-model="scope.row.territoryName" placeholder="请输入内容"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="right">
            <template slot-scope="scope">
              <!-- v-if="shbtn[scope.$index]" -->
              <div class="btn">
                <i
                  v-show="sh[scope.$index]"
                  @click="addSalesTerritory(scope.$index, scope.row.guid, scope.row.territoryName)"
                  class="el-icon-document-checked i-edit-sty"
                ></i>
                <i
                  v-show="!sh[scope.$index]"
                  class="el-icon-edit-outline i-edit-sty"
                  @click="upDataSalesTerritory(scope.$index)"
                ></i>
                <i class="el-icon-delete i-sty" @click="delDataSalesTerritory(scope.row.guid)"></i>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          :current-page="page.pageIndex"
          :page-size="page.pageSize"
          layout="prev, pager, next"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :total="page.totalRows"
        >
        </el-pagination>
      </div>
      <div class="right-content">
        <div class="search-area t-left">
          <div>
            <label class="font-S16">区域范围</label>
            <a class="fontC-4fa1a4 ml10 cursor-sty" @click="sales">维护区域范围</a>
          </div>
          <el-tag
            :key="tag.guid"
            type="info"
            v-for="tag in dynamicTags"
            closable
            class="mt15 mr15"
            :disable-transitions="false"
            @close="handleClose(tag)"
          >
            {{ tag.venue }}
          </el-tag>
        </div>
        <!-- <div class="search-area t-left mt15">
          <div>
            <label class="font-S16">区域指标</label>
            <a class="fontC-4fa1a4 ml10 cursor-sty" @click="detail()">维护指标</a>
          </div>
          <div class="mt15" v-if="salesTerritoryIndicatorList !=''">
            <el-tag type="info"
              >本年度指标（{{ salesTerritoryIndicatorList.year }}）：{{
                salesTerritoryIndicatorList.yearSalesIndicators | numFmt | numDigit
              }}元</el-tag
            >
            <el-tag type="info" class="ml15"
              >本月度指标（{{ salesTerritoryIndicatorList.startDate }}至{{ salesTerritoryIndicatorList.endDate }}）：{{
                salesTerritoryIndicatorList.salesIndicators | numFmt | numDigit
              }}元</el-tag
            >
          </div>
        </div> -->
        <div class="back-color-fff p16 borderR6 mt15">
          <div class="t-left">
            <div>
              <label class="font-S16">区域人员</label>
              <a class="fontC-4fa1a4 ml10 cursor-sty" @click="addPerson()">添加人员</a>
            </div>
            <!-- <label class="fontC-bcbec2">提示：【组织管理-人员管理】添加人员时，维护“人员所属销售区域”，即可在此显示对应人员</label> -->
          </div>
          <el-table :data="staffList" style="width: 100%; margin-top: 15px" border v-loading="loading">
            <!-- <el-table-column type="selection" width="60" header-align="center" align="center"></el-table-column> -->
            <el-table-column label="序号" width="60" header-align="center" align="center">
              <template slot-scope="scope">
                {{ scope.$index + 1 }}
              </template>
            </el-table-column>
            <el-table-column prop="staffName" label="姓名" header-align="center" align="center"> </el-table-column>
            <el-table-column prop="mobileNo" label="手机号" header-align="center" align="center"> </el-table-column>
            <el-table-column prop="staffType" label="人员类型" header-align="center" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.staffType | getstaffType }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="positionNames" label="岗位" header-align="center" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.positionNames | roleNames }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="bizState" label="状态" header-align="center" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.bizState | getBizState }}</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" header-align="center" align="center" width="70" fixed="right">
              <template slot-scope="scope">
                <a class="txt-color-red" @click="deletePerson(scope.row.guid)">删除</a>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!-- <el-pagination
          class="pt pb back-color-fff"
          background
          @size-change="handleSizeChange1"
          @current-change="handleCurrentChange1"
          :page-sizes="[10, 100, 200]"
          :current-page="page1.pageIndex"
          :page-size="page1.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="page1.totalRows"
        >
        </el-pagination> -->
      </div>
    </div>
    <el-dialog title="添加团队" :visible.sync="dialogVisible" width="40%" :before-close="close">
      <el-input placeholder="输入关键字进行过滤" v-model="filterText"> </el-input>
      <el-tree
        :data="superiorOrganization"
        ref="tree"
        class="mt10 mb10"
        show-checkbox
        :check-strictly="true"
        node-key="guid"
        :default-expanded-keys="defaultCheckedKeys"
        :default-checked-keys="defaultCheckedKeys"
        @check-change="handleCheckChange"
        :props="defaultPropsOrganisation"
      >
      </el-tree>
      <span slot="footer" class="dialog-footer">
        <el-button plain size="medium" @click="dialogVisible = false">取消</el-button>
        <el-button size="medium" type="info" @click="updateOrg">确定</el-button>
      </span>
    </el-dialog>
    <!-- 添加省 -->
    <el-dialog title="区域范围" :visible.sync="dialogVisibleProvince" width="40%" :before-close="close">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="区域范围:">
          <el-cascader
            :options="options"
            v-model="areaData"
            style="width: 100%"
            :props="{ multiple: true, checkStrictly: true }"
            clearable
            filterable
            @change="validateSelection"
          ></el-cascader>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button plain size="medium" @click="dialogVisibleProvince = false">取消</el-button>
        <el-button size="medium" type="info" @click="getProvince">确定</el-button>
      </span>
    </el-dialog>
    <!-- 添加人员 -->
    <el-dialog title="添加人员" :visible.sync="dialogPerson" width="40%">
      <el-select v-model="personId" multiple placeholder="请选择" class="w100f" filterable>
        <el-option v-for="ro in roleList" :key="ro.guid" :label="ro.appSideName" :value="ro.guid"> </el-option>
      </el-select>
      <span slot="footer" class="dialog-footer">
        <el-button plain size="medium" @click="dialogPerson = false">取消</el-button>
        <el-button size="medium" type="info" @click="updatePerson">确定</el-button>
      </span>
    </el-dialog>
    <!-- 批量添加指标 -->
    <el-dialog title="批量添加指标" :visible.sync="dialogFormVisible" width="550px">
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="120px"
        :label-position="right"
        class="demo-ruleForm"
      >
        <el-form-item label="年度:" prop="year">
          <el-date-picker v-model="ruleForm.year" class="w100f" type="year" value-format="yyyy" placeholder="选择年">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="月份:" prop="month">
          <el-date-picker
            v-model="ruleForm.month"
            class="w100f"
            type="month"
            value-format="yyyy-MM"
            @change="changeMonth"
            placeholder="选择年"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="起始-截止日期:" prop="timeList">
          <el-date-picker
            v-model="ruleForm.timeList"
            type="daterange"
            class="w100f"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-form-item>
        <div style="border-top: 1px solid #cccccc; height: 40px; line-height: 40px; text-align: right">
          合计已填写销售区：{{ salesDataSum }}个；指标金额(元)：{{ salesIndicatorsSum | numFmt | numDigit }}
        </div>
        <div v-for="(sa, index) in salesData" :key="index">
          <!-- <div>{{sa.territoryName}} <el-input v-model="sa.salesIndicators"></el-input></div> -->
          <el-form-item :label="sa.territoryName">
            <el-input-number
              v-model="sa.salesIndicators"
              @change="handleChange"
              :min="0"
              :precision="2"
              class="w100f"
            ></el-input-number>
          </el-form-item>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button plain size="medium" @click="dialogFormVisible = false">取消</el-button>
        <el-button size="medium" type="info" @click="submitForm('ruleForm')">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import areaJson from '../../assets/js/china_address_v4.js';
export default {
  data() {
    return {
      personId: [],
      roleList: [],
      areaData: [],
      options: areaJson,
      editableTabsValue: null,
      editableTabs: [],
      sh: [],
      shbtn: [],
      tabIndex: 10,
      currentRow: null,
      dynamicTags: [],
      inputVisible: false,
      inputValue: '',
      dialogVisible: false,
      filterText: '',
      superiorOrganization: [],
      defaultPropsOrganisation: {
        label: 'organisationName',
        children: 'children',
      },
      defaultCheckedKeys: [],
      guids: [],
      page: {
        pageIndex: 1,
        pageSize: 6,
        totalPage: 0,
        totalRows: 0,
      },
      page1: {
        pageIndex: 1,
        pageSize: 2,
        totalPage: 0,
        totalRows: 0,
      },
      tableData: [],
      loading: false,
      fillReceiptData: [],
      dialogVisibleProvince: false,
      ruleForm: {},
      rules: {},
      salesTerritoryGuid: '',
      areaDataList: [],
      salesTerritoryIndicatorList: '',
      staffList: [],
      dialogPerson: false,

      dialogFormVisible: false,
      ruleForm: {
        year: '',
        month: '',
        timeList: [],
      },
      right: '',
      rules: {
        year: [
          { required: true, message: '请选择年份', trigger: 'blur' },
          { min: 1, max: 60, message: '长度在 1 到 30 个字符', trigger: 'blur' },
        ],
        month: [
          { required: true, message: '请选择月份', trigger: 'blur' },
          { min: 1, max: 60, message: '长度在 1 到 30 个字符', trigger: 'blur' },
        ],
        timeList: [{ type: 'array', required: true, message: '请选择日期', trigger: 'change' }],
      },
      salesDataSum: 0,
      salesData: [],
      salesIndicatorsSum: 0,
    };
  },
  created() {
    // 列表
    this.getOrganizationLinkSales();
  },
  mounted() {
    // 列表
    // this.getSuperiorOrganization();
    // this.setCurrent(this.tableData[0]);
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
    editableTabsValue(val) {
      this.page.pageIndex = 1;
      this.getSalesTerritory();
    },
    // page: {
    //   handler(newValue, oldValue) {
    //     if (newValue.year == null) {
    //       this.page.year = '';
    //     }
    //   },
    //   deep: true,
    // },
  },
  methods: {
    validateSelection(selected) {
      console.log('选中的路径数组:', JSON.stringify(selected))
      
      if (!selected || selected.length < 2) return
      
      const sortedPaths = [...selected].sort((a, b) => b.length - a.length)
      const cleaned = []
      
      for (const path of sortedPaths) {
        // 检查当前路径是否是已保留路径的前缀（如果是，则当前路径为父级，应被排除）
        const isPrefixOfAny = cleaned.some(existingPath => {
          if (path.length >= existingPath.length) return false
          return path.every((val, idx) => val === existingPath[idx])
        })
        
        if (!isPrefixOfAny) {
          cleaned.push(path)
        }
      }
      
      // 只有当值确实发生变化时才更新，避免不必要的重新渲染
      const currentValue = JSON.stringify(this.areaData)
      const newValue = JSON.stringify(cleaned)
      
      if (currentValue !== newValue) {
        this.areaData = cleaned
        console.log('清理后的路径数组:', JSON.stringify(cleaned))
      }
    },
    changeTab(){
      alert('888')
    },
   handleChange(value) {
      let self = this;
      self.salesIndicatorsSum = 0;
      self.salesDataSum = 0;
      if(self.salesListData !==null){
        self.salesListData.forEach(function(item){
          if(item.salesIndicators){
              self.salesDataSum++;
              self.salesIndicatorsSum += item.salesIndicators
          } 
        })
      }
      console.log(self.salesIndicatorsSum);
    },
    changeMonth() {
      this.getSalesTerritoryData();
    },
    //获取组织的销售区域
    getSalesTerritoryII() {
      let self = this;
      let tenantGuid = self.$store.getters.getTenantGuid;
      let promise = {
        tenantGuid: tenantGuid,
        organisationGuid: self.editableTabsValue ,
        pageIndex: self.page.pageIndex,
        pageSize: '-1',
      };
      self.api.postJson(`/${serverConfig.msSalesPerformService}/sales-territory/data/get-sales-territory`, promise).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          if (res.data.data.records != null) {
            self.salesData = res.data.data.records;
            self.salesData.forEach((item) => {
              item.salesIndicators = 0;
            });
          }
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    getSalesTerritoryData() {
      let self = this;
      let promise = {
        pageIndex: 1,
        pageSize: -1,
        tenantGuid: self.$store.getters.getTenantGuid,
        salesTerritoryGuid: '',
        year: self.ruleForm.year,
        month: self.ruleForm.month.replace(/-/g, ''),
        organisationGuid: this.editableTabsValue ,
      };
      self.api
        .postJson(`/${serverConfig.msSalesPerformService}/sales-territory/data/get-page-sales-territory-indicator`, promise)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.salesListData = res.data.data.records;
            if (self.salesData !== null) {
              self.salesData.forEach((item) => {
                if (self.salesListData !== null) {
                  self.salesListData.forEach((items) => {
                    if (item.territoryName == items.salesTerritoryName) {
                      item.salesIndicators = items.salesIndicators;
                    }
                  });
                } else {
                  item.salesIndicators = 0;
                }
              });
            }
            if (self.salesListData !== null) {
              self.salesListData.forEach(function (item) {
                if (item.salesIndicators) {
                  self.salesDataSum++;
                  self.salesIndicatorsSum += item.salesIndicators;
                }
              });
            }
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    submitForm(formName) {
      let self = this;
      self.salesIndicators = [];
      self.$refs[formName].validate((valid) => {
        if (valid) {
          if (
            self.ruleForm.timeList &&
            Array.isArray(self.ruleForm.timeList) &&
            self.ruleForm.timeList.length > 0 &&
            self.ruleForm.timeList[0] &&
            self.ruleForm.timeList[1]
          ) {
            self.page.startDate = self.$moment(self.ruleForm.timeList[0]).format('YYYY-MM-DD');
            self.page.endDate = self.$moment(self.ruleForm.timeList[1]).format('YYYY-MM-DD');
          } else {
            self.page.startDate = '';
            self.page.endDate = '';
          }
          self.salesData.forEach(function (i) {
            let item = {
              tenantGuid: self.$store.getters.getTenantGuid,
              year: self.ruleForm.year,
              month: self.ruleForm.month.replace(/-/g, ''),
              startDate: self.page.startDate,
              endDate: self.page.endDate,
              salesTerritoryGuid: i.guid,
              salesIndicators: i.salesIndicators,
            };
            if (i.salesIndicators !== 0) {
              self.salesIndicators.push(item);
            }
          });
          self.api
            .postJson(
              `/${serverConfig.msSalesPerformService}/sales-territory/data/add-sales-territory-indicator`,
              self.salesIndicators,
            )
            .then((res) => {
              if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                self.dialogFormVisible = false;
                self.$message.success('添加指标成功');
                self.page.startDate = '';
                self.page.endDate = '';
                self.getData(true);
              } else {
                self.$message.error(res.data.msg);
              }
            });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    add() {
      let self = this;
      let date = new Date();
      let year = date.getFullYear().toString();
      let month = date.getMonth() + 1;
      let day = date.getDate();
      this.page.year = year;
      this.ruleForm.year = year;
      if (month < 10) {
        month = '0' + month;
      }
      this.ruleForm.month = date.getFullYear() + '-' + month;
      self.textTitle = '添加指标';
      self.ruleForm.timeList = [self.startDate, self.endDate];
      self.salesIndicatorsSum = 0;
      self.salesDataSum = 0;
      self.getSalesTerritoryData();
      self.getSalesTerritoryII();
      self.dialogFormVisible = true;
    },
    //tab
    handleTabsEdit(targetName, action) {
      let self = this;
      this.staffList = [];
      if (action === 'add') {
        self.guids = [];
        self.defaultCheckedKeys = [];
        if (self.editableTabs != null) {
          self.editableTabs.forEach((item) => {
            self.defaultCheckedKeys.push(item.guid);
            self.guids.push(item.guid);
          });
        }
        this.dialogVisible = true;
        this.getSuperiorOrganization();
      }
      if (action === 'remove') {
      }
    },
    //table 默认选中第一行
    // setCurrent(row) {
    //   this.$refs.singleTable.setCurrentRow(row);
    // },
    // handleCurrentChange(val) {
    //   this.currentRow = val;
    // },
    addSales() {
      this.sh[this.tableData.length] = true;
      this.tableData.push({});
    },
    cellMouseEnter: function (row) {
      let self = this;
      self.tableData.forEach(function (item, index) {
        if (row.guid == item.guid) {
          self.shbtn[index] = true;
        } else {
          self.shbtn[index] = false;
        }
        console.log(self.shbtn[index]);
      });
    },
    //标签
    handleClose(tag) {
      let self = this;
      self
        .$confirm('此操作将永久删除, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
        .then(() => {
          self.api
            .postJson(`/${serverConfig.msSalesPerformService}/sales-territory/data/delete-sales-territory-range?guid=${tag.guid}`)
            .then((res) => {
              if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                self.dynamicTags.splice(self.dynamicTags.indexOf(tag), 1);
                self.$message({
                  type: 'success',
                  message: '删除成功!',
                });
                self.getSalesTerritoryRange();
              } else {
                self.$message.error(res.data.msg);
              }
            });
        })
        .catch(() => {
          self.$message({
            type: 'info',
            message: '已取消删除！',
          });
        });
    },
    //获取人员
    addPerson(guid) {
      let self = this;
      if (self.salesTerritoryGuid == null || self.salesTerritoryGuid == '') {
        self.$message.error('请选择销售区域！');
        return;
      }
      self.personId = [];
      // if(self.staffList !== [] && self.staffList !== null){
      //   self.staffList.forEach(i =>{
      //     self.personId.push(i.guid);
      //   })
      // }
      self.dialogPerson = true;
      // alert(self.editableTabsValue)
      let promise = {
        pageIndex: 1,
        pageSize: -1,
        tenantGuid: self.$store.getters.getTenantGuid,
        staffType: '1',
        bizState: 'Y',
        containChildOrganisationGuid: self.editableTabsValue == '0'?null:self.editableTabsValue,
        isSalesTerritory: '1',
      };
      self.api.postJson(`/${serverConfig.msPersonnelService}/staff/data/get`, promise).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          let roleList = res.data.data.records;
          self.roleList = [];
          if (roleList != null) {
            roleList.forEach(function (j) {
              let item = {
                guid: j.guid,
                appSideName: j.staffName,
              };
              self.roleList.push(item);
            });
          }
          console.log(self.personId);
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    //新增人员
    updatePerson() {
      let self = this;
      let personList = {
        staffGuid: self.personId,
        salesTerritoryGuid: self.salesTerritoryGuid,
        tenantGuid: self.$store.getters.getTenantGuid,
        salesTerritoryName:self.salesTerritoryName
      };
      self.api
        .postJson(`/${serverConfig.msPersonnelService}/sales-territory/data/add-staff-sales-territory`, personList)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.$message.success('添加成功！');
            self.getStaffSalesTerritory();
            self.dialogPerson = false;
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    //删除人员
    deletePerson(guid) {
      let self = this;
      let guidList = [];
      guidList.push(guid);
      let personList = {
        staffGuid: guidList,
        salesTerritoryGuid: self.salesTerritoryGuid,
        tenantGuid: self.$store.getters.getTenantGuid,
      };
      self.api
        .postJson(`/${serverConfig.msPersonnelService}/sales-territory/data/delete-staff-sales-territory`, personList)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.$message.success('删除成功！');
            self.getStaffSalesTerritory();
            // self.dialogPerson = false;
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    // showInput() {
    //   this.inputVisible = true;
    //   this.$nextTick(_ => {
    //     this.$refs.saveTagInput.$refs.input.focus();
    //   });
    // },
    // handleInputConfirm() {
    //   let inputValue = this.inputValue;
    //   if (inputValue) {
    //     this.dynamicTags.push(inputValue);
    //   }
    //   this.inputVisible = false;
    //   this.inputValue = '';
    // },
    filterNode(value, data) {
      if (!value) return true;
      return data.organisationName.indexOf(value) !== -1;
    },
    //获取组织层级
    getSuperiorOrganization() {
      let self = this;
      let tenantGuid = self.$store.getters.getTenantGuid;
      self.api
        .get(`/${serverConfig.msPersonnelService}/organisation/data/get-organisation-detail?` + `tenantGuid=` + tenantGuid)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.superiorOrganization = res.data.data;
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    handleCheckChange(data, checked, indeterminate) {
      let self = this;
      console.log(data.guid, checked, indeterminate);
      if (checked) {
        self.guids.push(data.guid);
      } else {
        self.guids.forEach(function (item, index) {
          console.log(item);
          if (item == data.guid) {
            self.guids.splice(index, 1);
          }
        });
      }
      console.log(self.guids);
    },
    close() {
      this.dialogVisible = false;
      this.dialogVisibleProvince = false;
    },
    //获取存在销售区域的组织
    getOrganizationLinkSales() {
      let self = this;
      let tenantGuid = self.$store.getters.getTenantGuid;
      self.defaultCheckedKeys = [];
      const params = {
        pageIndex: 1,
        pageSize: -1,
        tenantGuid: tenantGuid,
        isLinkSalesTerritory: 'Y',
      }
      self.api
        .postJson(`/${serverConfig.msPersonnelService}/organisation/data/get`, params)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            if (res.data.data.records != null) {
              self.editableTabs = res.data.data.records?res.data.data.records:[];

              self.editableTabsValue = self.editableTabs.length?self.editableTabs[0].guid:null;
              self.getSalesTerritory();
            }
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    handleSizeChange(val) {
      let self = this;
      self.page.pageSize = val;
      this.getSalesTerritory();
    },
    handleCurrentChange(val) {
      let self = this;
      self.page.pageIndex = val;
      this.getSalesTerritory();
    },
    //获取组织的销售区域
    getSalesTerritory() {
      let self = this;
      let tenantGuid = self.$store.getters.getTenantGuid;
      let promise = {
        tenantGuid: tenantGuid,
        organisationGuid: self.editableTabsValue,
        pageIndex: self.page.pageIndex,
        pageSize: self.page.pageSize,
      };
      self.salesTerritoryIndicatorList = '';
      self.dynamicTags = [];
      self.api.postJson(`/${serverConfig.msSalesPerformService}/sales-territory/data/get-sales-territory`, promise).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.staffList=[];
          if (res.data.data.records != null) {
            self.tableData = res.data.data.records;
            self.tableData.forEach(function (i, index) {
              self.sh[i] = false;
            });

            self.page.totalRows = res.data.data.totalRows;
            console.log(self.tableData);
            self.salesTerritoryGuid = self.tableData[0].guid;
            self.salesTerritoryName = self.tableData[0].territoryName;
            console.log( self.salesTerritoryName )
            self.getSalesTerritoryRange();
            self.getStaffSalesTerritory();
            self.getSalesTerritoryIndicator();
          } else {
            self.tableData = [];
          }
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    addSalesTerritory(index, guid, name) {
      let self = this;
      let tenantGuid = self.$store.getters.getTenantGuid;
      if (guid) {
        let editPromise = {
          tenantGuid: tenantGuid,
          organisationGuid: self.editableTabsValue,
          territoryName: name,
          guid: guid,
        };
        self.api
          .postJson(`/${serverConfig.msSalesPerformService}/sales-territory/data/edit-sales-territory`, editPromise)
          .then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.$message.success('修改成功！');
              self.sh[index] = false;
              self.getSalesTerritory();
            } else {
              self.$message.error(res.data.msg);
            }
          });
      } else {
        let promise = {
          tenantGuid: tenantGuid,
          organisationGuid: self.editableTabsValue,
          territoryName: name,
        };
        self.api.postJson(`/${serverConfig.msSalesPerformService}/sales-territory/data/add-sales-territory`, promise).then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.$message.success('保存成功！');
            self.sh[index] = false;
            self.getSalesTerritory();
          } else {
            self.$message.error(res.data.msg);
          }
        });
      }
    },
    delDataSalesTerritory(guid) {
      let self = this;
      self.api.postJson(`/${serverConfig.msSalesPerformService}/sales-territory/data/del-sales-territory?guid=${guid}`).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.$message.success('删除成功！');
          self.getSalesTerritory();
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    upDataSalesTerritory(index) {
      let self = this;
      self.getSalesTerritory();
      self.sh[index] = true;
    },
    updateOrg() {
      let self = this;
      self.dialogVisible = false;
      self.api
        .put(`/${serverConfig.msSalesPerformService}/sales-territory/data/update-org-link-sales-territory`, self.guids)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.guids = [];
            self.$message.success('保存成功！');
            self.getOrganizationLinkSales();
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    handle(row, column, event) {
      let self = this;
      let tenantGuid = self.$store.getters.getTenantGuid;
      self.salesTerritoryName = row.territoryName;
      self.salesTerritoryGuid = row.guid;
      console.log( self.salesTerritoryName);
      self.getSalesTerritoryRange();
      self.getStaffSalesTerritory();
      self.getSalesTerritoryIndicator();
    },
    getSalesTerritoryRange() {
      if(!this.salesTerritoryGuid) return;
      let self = this;
      let promise = {
        // tenantGuid: tenantGuid,
        salesTerritoryGuid: self.salesTerritoryGuid,
        pageIndex: 1,
        pageSize: 30,
      };
      self.dynamicTags = [];
      self.api
        .postJson(`/${serverConfig.msSalesPerformService}/sales-territory/data/get-page-sales-territory-range`, promise)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            if (res.data.data.records != null) {
              self.dynamicTags = res.data.data.records;
              // res.data.data.records.forEach(item=>{
              //     self.dynamicTags.push(item.venue);
              // })
            } else {
              self.dynamicTags = [];
            }
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    sales() {
      let self = this;
      if (self.salesTerritoryGuid == null || self.salesTerritoryGuid == '') {
        self.$message.error('请选择销售区域！');
        return;
      }
      self.areaData = [];
      self.dynamicTags.forEach((i) => {
        if (i.city == null) {
          self.areaData.push([i.province]);
        } else if (i.district == null) {
          self.areaData.push([i.province, i.city]);
          // i.district = '';
        } else {
          self.areaData.push([i.province, i.city, i.district]);
        }
      });
      console.log(self.areaData);
      self.dialogVisibleProvince = true;
    },
    getProvince() {
      console.log(this.areaData);
      let self = this;
      let tenantGuid = self.$store.getters.getTenantGuid;
      self.areaDataList = [];
      this.areaData.forEach(function (item) {
        let venue = '';
        if (item[0] != null && item[0] != '') {
          venue = self.province(item[0]);
        }
        if (item[1] != null && item[1] != '') {
          venue = self.province(item[0]) + '/' + self.city(item[1]);
        }
        if (item[2] != null && item[2] != '') {
          venue = self.province(item[0]) + '/' + self.city(item[1]) + '/' + self.district(item[2]);
        }
        let promise = {
          tenantGuid: tenantGuid,
          salesTerritoryGuid: self.salesTerritoryGuid,
          province: item[0],
          city: item[1],
          district: item[2],
          venue: venue,
        };
        self.areaDataList.push(promise);
      });
      console.log(self.areaDataList);
      self.api
        .postJson(`/${serverConfig.msSalesPerformService}/sales-territory/data/add-update-sales-territory-range`, self.areaDataList)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.dialogVisibleProvince = false;
            this.areaData = [];
            self.getSalesTerritoryRange();
            // self.page.totalRows = res.data.data.totalRows;
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    province(val) {
      let pr = '';
      this.options.forEach(function (j) {
        if (j.value == val) {
          pr = j.label;
        }
      });
      return pr;
    },
    city(val) {
      let ci = '';
      this.options.forEach(function (i) {
        if (i.children != null && i.children != '') {
          i.children.forEach(function (j) {
            if (j.value == val) {
              ci = j.label;
            }
          });
        }
      });
      return ci;
    },
    district(val) {
      let di = '';
      this.options.forEach(function (i) {
        if (i.children != null && i.children != '') {
          i.children.forEach(function (j) {
            if (j.children != null && j.children != '') {
              j.children.forEach(function (n) {
                if (n.value == val) {
                  di = n.label;
                }
              });
            }
          });
        }
      });
      return di;
    },
    getStaffSalesTerritory() {
      let self = this;
      self.api
        .get(
          `/${serverConfig.msPersonnelService}/sales-territory/data/get-staff-sales-territory?salesTerritoryGuid=` +
            self.salesTerritoryGuid,
        )
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.staffList = res.data.data.records;
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    detail() {
      if (this.salesTerritoryGuid == null || this.salesTerritoryGuid == '') {
        this.$message.error('请选择销售区域！');
        return;
      }
      this.$router.push({
        path: '/salesAreaMaintenanceIndex',
        query: { guid: this.editableTabsValue, salesTerritoryGuid: this.salesTerritoryGuid },
      });
    },
    getSalesTerritoryIndicator() {
      let self = this;
      let tenantGuid = self.$store.getters.getTenantGuid;
      let date = new Date();
      let promise = {
        tenantGuid: tenantGuid,
        salesTerritoryGuid: self.salesTerritoryGuid,
        year: tenantGuid,
        year: date.getFullYear().toString(),
        startDate: '',
        endDate: '',
      };
      self.salesTerritoryIndicatorList = '';
      self.dynamicTags = [];
      self.api
        .postJson(`/${serverConfig.msSalesPerformService}/sales-territory/data/get-sales-territory-indicator`, promise)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.staffList = [];
            if (res.data.data != null) {
              self.salesTerritoryIndicatorList = res.data.data;
            }
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
  },
};
</script>